const getters = {
  columnFilters: state => state.app.columnFilters
}
export default getters

